const LOGGER_PREFIX_UX_LIB = "ux-lib-react";
export {
  LOGGER_PREFIX_UX_LIB
};
//# sourceMappingURL=constants.js.map
